import { useRef as r } from "react";
import { useEvent as u } from './use-event.js';
import { useEventListener as o } from './use-event-listener.js';
function i(e) {
  var n = r({
    value: "",
    selectionStart: null,
    selectionEnd: null
  });
  return o(e, "blur", function (l) {
    var t = l.target;
    t instanceof HTMLInputElement && (n.current = {
      value: t.value,
      selectionStart: t.selectionStart,
      selectionEnd: t.selectionEnd
    });
  }), u(function () {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({
        preventScroll: !0
      }), e.value !== n.current.value) e.setSelectionRange(e.value.length, e.value.length);else {
        var _n$current = n.current,
          l = _n$current.selectionStart,
          t = _n$current.selectionEnd;
        l !== null && t !== null && e.setSelectionRange(l, t);
      }
      n.current = {
        value: "",
        selectionStart: null,
        selectionEnd: null
      };
    }
  });
}
export { i as useRefocusableInput };